<template>
    <div class="container-fluid d-flex pt-3 flex-wrap main-wrapper bg-dark h-100vh">
        <!-- <div class="col-lg-3 col-12 pl-0 side-nav-bar-custom">
            <SideNav />
        </div> -->
        <div class="col-lg-12 col-12 p-0 mb-5">
            <div class="card">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col-8">
                            <h3 class="mb-0">
                                {{ $store.state.language === "en" ? "Deposit" : "ငွေသွင်း" }}
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <form>
                        <h6 class="heading-small">
                            {{
                                $store.state.language === "en"
                                    ? "Account information"
                                    : "အကောင့်ဆိုင်ရာ အချက်အလက်များ"
                            }}
                        </h6>
                        <span class="heading-small">{{ $store.state.language === "en" ? "User's Balance" : "လက်ကျန်ငွေ"
                        }} -
                        </span>
                        <span>
                            <b class="text-danger">{{
                                Number($store.state.amount).toLocaleString()
                            }}</b>
                            {{ $store.state.language === "en" ? "RM" : "RM" }}
                        </span>
                        <div class="pl-lg-4 mt-4">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label
                                            class="form-control-label"
                                            for="input-username"
                                        >{{
                                            $store.state.language === "en"
                                                ? "Choose Payment Type"
                                                : "ငွေပေးချေမူပုံစံ ရွေးချယ်ပါ"
                                        }}</label>
                                        <AccountSelect
                                            :data="selected_account"
                                            field="account_id"
                                            :accounts="accounts"
                                        />
                                        <span class="text-danger">{{ errors.account }}</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-12 p-0 d-flex flex-wrap"
                                v-if="account.length !== 0"
                            >
                                <div class="col-lg-6 col-12 py-5">
                                    <h3>{{ account[0].name }}</h3>
                                    <div class="number-container d-flex py-3 my-2">
                                        {{ $store.state.language === "en" ? "Account Name" : "အကောင့် အမည်" }}
                                        :
                                        <h3 class="m-0">&nbsp;{{ account[0].account_name }}</h3>
                                    </div>
                                    <div class="number-container d-flex py-3 my-2">
                                        {{ $store.state.language === "en" ? "Number" : "အကောင့် နံပါတ်" }}
                                        :
                                        <h3
                                            class="m-0"
                                            id="textToCopy"
                                        >&nbsp;{{ account[0].number }}</h3>
                                        <span
                                            class="ml-5 text-danger badge badge-danger"
                                            @click="copyText"
                                        >Copy</span>
                                    </div>
                                    <b
                                        class="text-sm"
                                        v-if="$store.state.language === 'en'"
                                    >
                                        Please charge amount to that account, save the voucher screenshot, and upload it
                                        using the file input.
                                    </b>
                                    <b
                                        class="text-sm"
                                        v-else
                                    >
                                        ဖော်ပြထားသောအကောင့်ကို ငွေလွဲပေးပါ။
                                        ရရှိလာတဲ့ငွေပေးချေမှုအောင်မြင်မှုကိုမှတ်တမ်းတင် (screenshot) ရိုက်ထားပြီး၊
                                        ထိုမှတ်တမ်းတင်ပုံကို admin ဆီသို့ upload ပြုလုပ်ပါ။
                                    </b>
                                </div>
                            </div>
                            <span class="text-danger">{{ errors.limit }}</span>
                        </div>
                        <hr class="my-4" />
                        <div class="pl-lg-4">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="form-control-label">{{
                                            $store.state.language === "en"
                                                ? "Screenshot"
                                                : "ငွေပေးချေမူ ဓာက်ပုံ"
                                        }}</label>

                                        <div class="custom-file d-flex">
                                            <van-uploader
                                                class="mx-auto"
                                                v-model="imageUploader"
                                                :max-count="1"
                                            />
                                        </div>
                                        <span class="text-danger">{{ errors.image }}</span>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label
                                            class="form-control-label"
                                            for="input-email"
                                        >{{
                                            $store.state.language === "en" ? "Amount" : "ငွေပမာဏ"
                                        }}</label>
                                        <span class="text-danger text-xs">{{
                                            $store.state.language === "en"
                                                ? " ( Minimum amount 3,000 )"
                                                : " ( အနည်းဆုံး 3,000 )"
                                        }}</span>
                                        <input
                                            type="number"
                                            id="input-email"
                                            class="form-control"
                                            v-model="depositData.amount"
                                        />
                                        <span class="text-danger">{{ errors.amount }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pl-lg-4">
                            <!-- <div class="form-group">
                                <label class="form-control-label">{{
                                    $store.state.language === "en"
                                        ? "Last Transaction Id 6"
                                        : "လုပ်ဆောင်မှုအမှတ်စဉ် (နောက်ဆုံး ၆ လုံး)"
                                }}</label>
                                <input
                                    type="number"
                                    id="input-email"
                                    class="form-control"
                                    v-model="depositData.remark"
                                />
                                <span class="text-danger">{{
                                    errors.remark
                                }}</span>

                            </div> -->
                            <div class="form-group">
                                <button
                                    type="button"
                                    :disabled="isConfirm"
                                    class="btn btn-primary"
                                    @click="sendDepositData"
                                >
                                    <div v-if="!isConfirm">
                                        {{ $store.state.language === "en" ? "Confirm" : "အတည်ပြုမည်" }}
                                    </div>

                                    <Loading
                                        color="#ffffff"
                                        v-if="isConfirm"
                                        size="24"
                                        class="px-4 py-0"
                                    />
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Loading } from "vant";
import { mapActions } from "vuex";
import AccountSelect from "./components/AccountSelect.vue";

export default {
    components: { AccountSelect, Loading },
    data() {
        return {
            selected_account: {},
            accounts: [],
            account: [],
            imageUploader: [],
            depositData: {},
            errors: {},
            isConfirm: false,
        };
    },
    methods: {
        ...mapActions(["fetchUser"]),
        copyText() {
            // Get the text to copy
            const textToCopy = document.getElementById("textToCopy").innerText;

            // Create a temporary textarea element
            const textarea = document.createElement("textarea");
            textarea.value = textToCopy;

            // Append the textarea to the DOM
            document.body.appendChild(textarea);

            // Select the text in the textarea
            textarea.select();

            // Execute the 'copy' command
            document.execCommand("copy");

            // Remove the temporary textarea
            document.body.removeChild(textarea);

            alert("You have copy Phone Number");
        },
        async fetchAccounts() {
            try {
                const res = await axios.get("/accounts", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });
                this.accounts = res.data.data;

                // Group objects by name
                // const groupedByName = this.accounts.reduce((acc, obj) => {
                //     acc[obj.name] = acc[obj.name] || [];
                //     acc[obj.name].push(obj);
                //     return acc;
                // }, {});

                // // Get a random object from each group
                // const getRandomObjectFromGroup = (group) => {
                //     const randomIndex = Math.floor(Math.random() * group.length);
                //     return group[randomIndex];
                // };

                // // Collect the random objects into a single array
                // this.accounts = Object.keys(groupedByName).map(name => getRandomObjectFromGroup(groupedByName[name]));
            } catch (error) {
                console.log(error);
            }
        },
        async sendDepositData() {
            try {
                const authUser = await this.fetchUser();
                this.errors = {};
                if (!this.selected_account.account_id) {
                    this.errors.account =
                        this.$store.state.language === "en"
                            ? "Please pick account type"
                            : "အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။";
                    return false;
                }
                if (!this.imageUploader.length > 0) {
                    this.errors.image =
                        this.$store.state.language === "en"
                            ? "Please insert screenshot photo"
                            : "ငွေပေးချေမူမှတ်တမ်း (screenshot) ထည့်သွင်းပါ။";
                    return false;
                }
                if (!this.depositData.amount) {
                    this.errors.amount =
                        this.$store.state.language === "en"
                            ? "Please enter amount"
                            : "ငွေပမာဏထည့်ပေးပါ။";
                    return false;
                }
                if (!this.depositData.amount) {
                    this.errors.amount =
                        this.$store.state.language === "en"
                            ? "Please enter amount"
                            : "ငွေပမာဏထည့်ပေးပါ။";
                    return false;
                }
                if (this.depositData.amount < this.$site.minDeposit) {
                    this.errors.amount = this.$t('deposit.minAmount');
                    return false;
                }
                // if (!this.depositData.remark) {
                //   this.errors.remark = this.$store.state.language === 'en'
                //     ? 'Please enter last transaction id 6'
                //     : 'Please enter last transaction id 6';
                //   return false;
                // }
                this.isConfirm = true;
                if (this.imageUploader[0]) {
                    this.depositData.transaction_image = this.imageUploader[0].content;
                }
                this.depositData.account_id = this.account[0].id;
                this.depositData.date = this.currentTime;
                const res = await axios.post("/deposits", this.depositData, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });
                this.imageUploader = [];
                this.depositData = {};
                this.selected_account.account_id = null;
                Toast.success(this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။");
                this.isConfirm = false;
            } catch (error) {
                console.log(error);
                this.errors.limit = error.response.data;
                Toast.fail(this.$store.state.language === "en" ? "Fail" : "ကျရှုံးသည်။");
                this.isConfirm = false;
            }
            return true;
        },
        createDateWithTimeZone() {
            const moment = require("moment-timezone");
            const dateInTimeZone = moment.tz(new Date(), "Asia/Rangoon");
            // Extract individual components from moment object
            const year = dateInTimeZone.year();
            const month = dateInTimeZone.month();
            const day = dateInTimeZone.date();
            const hour = dateInTimeZone.hour();
            const minute = dateInTimeZone.minute();
            const second = dateInTimeZone.second();
            const millisecond = dateInTimeZone.millisecond();

            // Create a new Date object with the extracted components
            const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
            return newDateObject;
        },
    },
    watch: {
        "selected_account.account_id": function () {
            this.account = this.accounts.filter(
                (account) => account.id === this.selected_account.account_id
            );
        },
    },
    computed: {
        currentTime() {
            return moment(this.createDateWithTimeZone()).format("lll");
        },
    },
    async mounted() {
        this.fetchAccounts();
        const authUser = await this.fetchUser();
        if (!authUser) {
            this.$router.push("/auth/login");
        }
    },
};
</script>
<style scoped>
.image-container {
    width: 200px;
    height: 200px;
}

.image-container img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}

.number-container {
    border-radius: 5px;
    background: #e9ecef;
    justify-content: center;
}

.custom-file {
    height: auto;
}

@media (max-width: 768px) {
    .main-wrapper {
        padding: 7px !important;
    }
}
</style>
